import React from 'react';
import PropTypes from 'prop-types';

import BannerSettingsPresenter, {
  BANNER_TYPES,
} from '../../../../../../../presenters/BannerSettingsPresenter';
import Label from '../../../../../../../components/Label';
import Select from '../../../../../../../components/Select';

const BannerTypeSelect = (props) => {
  const { id, defaultValue, onChange, textLabel, errors } = props;

  const options = Object.values(BANNER_TYPES).map((bannerType) => {
    return {
      value: bannerType,
      label: BannerSettingsPresenter.bannerTypeReadable({ bannerType }),
    };
  });
  const defaultOption = { value: '', label: '-- Choose type --<' };

  return (
    <div>
      <Label name={id} title={textLabel} errors={errors} />
      <Select
        id={id}
        value={defaultValue}
        onChange={onChange}
        required
        disabled
        options={options}
        defaultOption={defaultOption}
      />
    </div>
  );
};
export default BannerTypeSelect;

BannerTypeSelect.propTypes = {
  id: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  textLabel: PropTypes.string.isRequired,
  errors: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
};

BannerTypeSelect.defaultProps = {
  errors: {},
};
